(() => {
  if (window.realPeopleResultsScriptInitialized) return;

  window.realPeopleResultsScriptInitialized = true;
  const rootSelector = '[data-real-people-results]';

  const initializeSlider = (root) => {
    if (root.dataset.realPeopleResultsInitialized === 'true') return;

    const track = root.querySelector('[data-slider-track]');
    const slides = [...root.querySelectorAll('[data-slider-slide]')];
    const previousButton = root.querySelector('[data-slider-previous]');
    const nextButton = root.querySelector('[data-slider-next]');
    const pagination = root.querySelector('[data-slider-pagination]');

    if (!track || slides.length === 0 || typeof window.Swiper !== 'function') return;

    root.dataset.realPeopleResultsInitialized = 'true';

    const videoVisibilityObserver = typeof window.IntersectionObserver === 'function'
      ? new window.IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) return;

            const video = entry.target.querySelector('video');
            if (video && !video.muted) video.muted = true;
          });
        })
      : null;

    root.realPeopleResultsVideoObserver = videoVisibilityObserver;

    root.querySelectorAll('[data-video-card]').forEach((card) => {
      const video = card.querySelector('video');
      const playbackButton = card.querySelector('[data-video-toggle]');
      const muteButton = card.querySelector('[data-video-mute-toggle]');
      if (!video) return;

      videoVisibilityObserver?.observe(card);
      if (!playbackButton || !muteButton) return;

      const updatePlaybackState = () => {
        const isPlaying = !video.paused && !video.ended;
        card.classList.toggle('is-playing', isPlaying);
        playbackButton.setAttribute('aria-label', isPlaying ? root.dataset.pauseLabel : root.dataset.playLabel);
        playbackButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      };

      const updateMuteState = () => {
        card.classList.toggle('is-muted', video.muted);
        muteButton.setAttribute('aria-label', video.muted ? root.dataset.unmuteLabel : root.dataset.muteLabel);
        muteButton.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      };

      const muteOtherVideos = () => {
        document.querySelectorAll('.real-people-results__video').forEach((otherVideo) => {
          if (otherVideo !== video) otherVideo.muted = true;
        });
      };

      playbackButton.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      muteButton.addEventListener('click', () => {
        if (video.muted) {
          muteOtherVideos();
          video.muted = false;
        } else {
          video.muted = true;
        }
        updateMuteState();
      });

      video.addEventListener('play', updatePlaybackState);
      video.addEventListener('pause', updatePlaybackState);
      video.addEventListener('ended', updatePlaybackState);
      video.addEventListener('volumechange', () => {
        if (!video.muted) muteOtherVideos();
        updateMuteState();
      });

      video.muted = true;
      video.defaultMuted = true;
      updatePlaybackState();
      updateMuteState();
      video.play().catch(() => {});
    });

    root.realPeopleResultsSwiper = new window.Swiper(track, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      freeMode: {
        enabled: true
      },
      keyboard: {
        enabled: true
      },
      navigation: {
        enabled: false,
        prevEl: previousButton,
        nextEl: nextButton
      },
      pagination: pagination ? {
        el: pagination,
        clickable: true
      } : undefined,
      breakpoints: {
        1200: {
          freeMode: {
            enabled: false
          },
          navigation: {
            enabled: true
          }
        }
      }
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.(rootSelector)) initializeSlider(scope);
    scope.querySelectorAll?.(rootSelector).forEach(initializeSlider);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(rootSelector)
      ? event.target
      : event.target.querySelector?.(rootSelector);
    root?.realPeopleResultsVideoObserver?.disconnect();
    root?.realPeopleResultsSwiper?.destroy(true, true);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-slider-slide]');
    const root = slide?.closest(rootSelector);
    if (!slide || !root) return;

    root.realPeopleResultsSwiper?.slideTo(Math.floor(Number(slide.dataset.sliderSlide) / 2));
  });
})();
